import type { MsalAuthenticationResult } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { useEffect, useRef } from 'react';

import { msalScopes } from '~config';
import { requiresInteractiveAuth } from './authService';

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * Fallback rendered when MsalAuthenticationTemplate encounters an auth error
 * (e.g. block_iframe_reload after a stale session). Triggers a fresh interactive
 * login redirect to clear the broken MSAL state from localStorage.
 */
const AuthErrorFallback = ({ error }: MsalAuthenticationResult) => {
  const { instance } = useMsal();
  const redirectInProgressRef = useRef(false);

  useEffect(() => {
    if (!error || !requiresInteractiveAuth(error) || redirectInProgressRef.current) return;

    redirectInProgressRef.current = true;

    instance.loginRedirect({ scopes: [...msalScopes.login] }).catch((redirectError) => {
      redirectInProgressRef.current = false;
      console.error(redirectError);
    });
  }, [error, instance]);

  return null;
};

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { AuthErrorFallback };
